import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useContext } from 'react';
import NewFormFilling from '../components/NewFormFilling/Structure/NewFormFilling';
import LinkExterno from '../components/Reports/Modal/LinkExterno';
import { AuthContext, AuthProvider } from '../context/AuthContext';
import NewFormProvider from '../context/NewFormContext';
import UserProvider from '../context/UserContext';
import WebFormProvider from '../context/WebFormContext';
import Aprovations from '../pages/Aprovations';
import Checklists from '../pages/Checklists';
import Clients from '../pages/Clients';
import Filling from '../pages/Filling';
import Fluxo from '../pages/Fluxo';
import FormularioById from '../pages/FormularioById';
import Home from '../pages/Home';
import Login from '../pages/Login';
import SsoComplete from '../pages/SsoComplete';
import Managements from '../pages/Managements';
import Notifications from '../pages/Notifications';
import Places from '../pages/Places';
import PlanoDeAcao from '../pages/PlanoDeAcao';
import PrivacyTerms from '../pages/PrivacyTerms';
import Recuperacao from '../pages/Recuperacao';
import Reports from '../pages/Reports';
import Researches from '../pages/Researches';
import Services from '../pages/Services';
import Settings from '../pages/Settings';
import Statistics from '../pages/Statistics';
import Teams from '../pages/Teams';
import TicketInPath from '../pages/TicketInPath';
import Tickets from '../pages/Tickets';
import Users from '../pages/Users';
import { PrivateRoute } from './PrivateRoute';
import Public from '../pages/Public';
import AuthLoading from '../pages/AuthLoading';

export default function Rotas() {
  return (
    <BrowserRouter>
      <UserProvider>
        <WebFormProvider>
          <NewFormProvider>
            <AuthProvider>
              <Routes>
                <Route path="/termos-privacidade" element={<PrivacyTerms />} />
                <Route path="/home" element={
                  <PrivateRoute>
                    <Home />
                  </PrivateRoute>
                } />
                <Route path="/preenchedor/:formId" element={<NewFormFilling />} />
                <Route path="/:aliasEmpresa/:aliasChecklist" element={<Public />} />
                <Route path="/detalhe-checklist/:formId/:user/:timestamp" element={<LinkExterno />} />
                <Route path="/detalhe-checklist/:formId/:user" element={<LinkExterno />} />
                <Route path="/" element={<AuthLanding />} />
                <Route path="/resetPassword/:uid" element={<Recuperacao />} />
                <Route path="/login" element={<LoginLanding />} />
                <Route path="/auth/sso/complete" element={<SsoComplete />} />
                <Route path="/notificacaoWeb" element={
                  <PrivateRoute>
                    <Notifications />
                  </PrivateRoute>
                } />
                <Route path="/estatisticas" element={
                  <PrivateRoute>
                    <Statistics />
                  </PrivateRoute>
                } />
                <Route path="/fluxo" element={
                  <PrivateRoute>
                    <Fluxo />
                  </PrivateRoute>
                } />
                <Route path="/pesquisas" element={
                  <PrivateRoute>
                    <Researches />
                  </PrivateRoute>
                } />
                <Route path="/fluxo" element={
                  <PrivateRoute>
                    <Fluxo />
                  </PrivateRoute>
                } />
                <Route path={`/detalheChamado/:id`} element={
                  <PrivateRoute>
                    <TicketInPath />
                  </PrivateRoute>
                } />
                <Route path="/plano-de-acao" element={
                  <PrivateRoute>
                    <PlanoDeAcao />
                  </PrivateRoute>
                } />
                <Route path="/configuracoes" element={
                  <PrivateRoute>
                    <Settings />
                  </PrivateRoute>
                } />
                <Route path="/aprovacao" element={
                  <PrivateRoute>
                    <Aprovations />
                  </PrivateRoute>
                } />
                <Route path="/usuarios" element={
                  <PrivateRoute>
                    <Users />
                  </PrivateRoute>
                } />
                <Route path="/locais" element={
                  <PrivateRoute>
                    <Places />
                  </PrivateRoute>
                } />
                <Route path="/servicos" element={
                  <PrivateRoute>
                    <Services />
                  </PrivateRoute>
                } />
                <Route path="/formularios" element={
                  <PrivateRoute>
                    <Checklists />
                  </PrivateRoute>
                } />
                <Route path={`/formularios/:id`} element={
                  <PrivateRoute>
                    <FormularioById />
                  </PrivateRoute>
                } />
                <Route path="/clientes" element={
                  <PrivateRoute>
                    <Clients />
                  </PrivateRoute>
                } />
                <Route path="/equipes" element={
                  <PrivateRoute>
                    <Teams />
                  </PrivateRoute>
                } />
                <Route path="/relatorios" element={
                  <PrivateRoute>
                    <Reports />
                  </PrivateRoute>
                } />
                <Route path="/gerencias" element={
                  <PrivateRoute>
                    <Managements />
                  </PrivateRoute>
                } />
                <Route path="/notificacoes" element={
                  <PrivateRoute>
                    <Tickets />
                  </PrivateRoute>
                } />
                <Route path="/preenchimento" element={
                  <PrivateRoute>
                    <Filling />
                  </PrivateRoute>
                } />
              </Routes>
            </AuthProvider>
          </NewFormProvider>
        </WebFormProvider>
      </UserProvider>
    </BrowserRouter >
  );
}

function AuthLanding() {
  const { status } = useContext(AuthContext);
  return status === 'authenticated' ? <Navigate to="/home" replace /> : <Navigate to="/login" replace />;
}

function LoginLanding() {
  const { status } = useContext(AuthContext);

  if (status === 'initializing') {
    return <AuthLoading />;
  }

  return status === 'authenticated' ? <Navigate to="/home" replace /> : <Login />;
}
